module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    class: _vm.listCss
  }, [_c('user-list', {
    attrs: {
      "title": _vm.title,
      "users": _vm.coachedUsers,
      "selectedUserId": _vm.selectedUserId,
      "canAdd": false
    },
    on: {
      "addUser": function($event) {
        _vm.addUserDialog = true
      },
      "deleteUser": _vm.deleteUser,
      "userSelected": _vm.userSelected
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    class: _vm.detailCss
  }, [_c('router-view', {
    on: {
      "userIdChanged": _vm.userIdChanged
    }
  })], 1), _vm._v(" "), _c('v-dialog', {
    attrs: {
      "persistent": "",
      "max-width": "400"
    },
    model: {
      value: (_vm.addUserDialog),
      callback: function($$v) {
        _vm.addUserDialog = $$v
      },
      expression: "addUserDialog"
    }
  }, [_c('v-form', {
    ref: "form",
    attrs: {
      "lazy-validation": ""
    },
    model: {
      value: (_vm.valid),
      callback: function($$v) {
        _vm.valid = $$v
      },
      expression: "valid"
    }
  }, [_c('v-card', [_c('v-card-title', {
    staticClass: "headline grey lighten-2"
  }, [_vm._v("Ajout d'un utilisateur")]), _vm._v(" "), _c('v-card-text', [_c('v-container', {
    attrs: {
      "grid-list-md": ""
    }
  }, [_c('v-layout', {
    attrs: {
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-autocomplete', {
    attrs: {
      "label": "Patient",
      "loading": _vm.loading,
      "cache-items": "",
      "item-text": "fullname",
      "item-value": "id",
      "required": "",
      "items": _vm.items,
      "search-input": _vm.search
    },
    on: {
      "update:searchInput": function($event) {
        _vm.search = $event
      }
    },
    model: {
      value: (_vm.userToAddId),
      callback: function($$v) {
        _vm.userToAddId = $$v
      },
      expression: "userToAddId"
    }
  })], 1)], 1)], 1)], 1), _vm._v(" "), _c('v-card-actions', [_c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "color": "brown darken-2",
      "flat": "",
      "disabled": !_vm.valid
    },
    nativeOn: {
      "click": function($event) {
        _vm.addUserDialog = false;
        _vm.addUser()
      }
    }
  }, [_vm._v("OK")]), _vm._v(" "), _c('v-btn', {
    attrs: {
      "color": "brown darken-2",
      "flat": ""
    },
    nativeOn: {
      "click": function($event) {
        _vm.addUserDialog = false
      }
    }
  }, [_vm._v("Annuler")])], 1)], 1)], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-3adf1ff2","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/coaching/Coaching.vue
// module id = 1184
// module chunks = 1